var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendrierRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.67511 0.5C7.19493 0.5 7.61633 0.905262 7.61633 1.40517V3.23109C8.45122 3.21551 9.38704 3.21551 10.44 3.21551H15.4599C16.5128 3.21551 17.4486 3.21551 18.2835 3.23109V1.40517C18.2835 0.905262 18.7049 0.5 19.2248 0.5C19.7445 0.5 20.166 0.905262 20.166 1.40517V3.31117C21.9723 3.45027 23.1581 3.79166 24.0293 4.62949C24.9005 5.46731 25.2555 6.6077 25.4001 8.34482L25.4998 9.25H1.65546H0.499756V8.34482C0.644393 6.6077 0.999381 5.46731 1.87057 4.62949C2.74177 3.79166 3.92758 3.45027 5.73388 3.31117V1.40517C5.73388 0.905262 6.15528 0.5 6.67511 0.5Z",
    fill: "#A70606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.4994 15.5001V13.0001C25.4994 11.9513 25.4954 10.0816 25.4793 9.25H0.511536C0.495398 10.0816 0.499486 11.9513 0.499486 13.0001V15.5001C0.499486 20.2141 0.499486 22.5711 1.96395 24.0356C3.42841 25.5001 5.78544 25.5001 10.4995 25.5001H15.4994C20.2136 25.5001 22.5706 25.5001 24.0351 24.0356C25.4994 22.5711 25.4994 20.2141 25.4994 15.5001Z",
    fill: "#A70606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19.25C20.5 19.9404 19.9404 20.5 19.25 20.5C18.5596 20.5 18 19.9404 18 19.25C18 18.5596 18.5596 18 19.25 18C19.9404 18 20.5 18.5596 20.5 19.25Z",
    fill: "#A70606"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.25C20.5 14.9404 19.9404 15.5 19.25 15.5C18.5596 15.5 18 14.9404 18 14.25C18 13.5596 18.5596 13 19.25 13C19.9404 13 20.5 13.5596 20.5 14.25Z",
    fill: "#A70606"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 19.25C14.25 19.9404 13.6904 20.5 13 20.5C12.3096 20.5 11.75 19.9404 11.75 19.25C11.75 18.5596 12.3096 18 13 18C13.6904 18 14.25 18.5596 14.25 19.25Z",
    fill: "#A70606"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 14.25C14.25 14.9404 13.6904 15.5 13 15.5C12.3096 15.5 11.75 14.9404 11.75 14.25C11.75 13.5596 12.3096 13 13 13C13.6904 13 14.25 13.5596 14.25 14.25Z",
    fill: "#A70606"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.25C8 19.9404 7.44035 20.5 6.75 20.5C6.05965 20.5 5.5 19.9404 5.5 19.25C5.5 18.5596 6.05965 18 6.75 18C7.44035 18 8 18.5596 8 19.25Z",
    fill: "#A70606"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.25C8 14.9404 7.44035 15.5 6.75 15.5C6.05965 15.5 5.5 14.9404 5.5 14.25C5.5 13.5596 6.05965 13 6.75 13C7.44035 13 8 13.5596 8 14.25Z",
    fill: "#A70606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendrierRed);
export default __webpack_public_path__ + "static/media/calendrierRed.bdcd8c879abdfff33a30d0626a254d18.svg";
export { ForwardRef as ReactComponent };